// extracted by mini-css-extract-plugin
export default {"box":"Giveaway_box__8uvo+","btn":"Giveaway_btn__IKE4s","unactive":"Giveaway_unactive__Tss2w","add":"Giveaway_add__-C4Ld","delete":"Giveaway_delete__pt37I"};